import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { styled } from 'shell/components';
import { preserveMarkdownLineBreaks } from 'utils/chat/chatHelpers';

export const ChatMarkdownLink = ({ children, ...props }) => (
    <a {...props} target={'_blank'} rel={'noopener noreferrer'}>
        {children}
    </a>
);

const TableScrollWrapper = styled('div')(({ theme }) => ({
    overflowX: 'auto',
    width: '100%',
    marginTop: theme.spacing(2),
}));

export const ChatMarkdownTable = ({ node, ...props }) => (
    <TableScrollWrapper>
        <table {...props} />
    </TableScrollWrapper>
);

export const getChatMarkdownStyles = ({ theme }) => {
    const borderStyle = `1px solid ${theme.palette.ensightful.neutral[200]}`;

    return {
        lineHeight: '20px',
        maxWidth: '100%',
        // overflowX: 'auto',

        '& p': {
            margin: 0,
        },
        '& a': {
            color: theme.palette.ensightful.primary[500],
            textDecorationColor: theme.palette.ensightful.primary[500],
            textUnderlineOffset: '2px',

            '&:hover': {
                color: theme.palette.ensightful.primary[700],
                textDecorationColor: theme.palette.ensightful.primary[700],
            },

            '&:active': {
                color: theme.palette.ensightful.primary[800],
                textDecorationColor: theme.palette.ensightful.primary[800],
            },
        },
        '& ul': {
            margin: 0,
            paddingLeft: theme.spacing(4),
        },
        '& ol': {
            margin: 0,
            paddingLeft: theme.spacing(6),
        },
        '& ul, & ol': {
            listStylePosition: 'outside',
        },
        '& ul + p, & ol + p, & p + ul, & p + ol': {
            marginTop: theme.spacing(2),
        },
        '& li + li': {
            marginTop: theme.spacing(0.5),
        },
        '& li > p': {
            margin: 0,
        },
        '& h1, & h2, & h3, & h4, & h5, & h6': {
            margin: 0,
            fontSize: 'inherit',
            fontWeight: 500,
            lineHeight: 'inherit',
        },
        '& h1 + p, & h2 + p, & h3 + p, & h4 + p, & h5 + p, & h6 + p': {
            marginTop: theme.spacing(1),
        },
        '& pre, & blockquote': {
            margin: 0,
        },
        '& p + p': {
            marginTop: theme.spacing(2),
        },
        '& table': {
            border: borderStyle,
            borderCollapse: 'separate',
            borderRadius: '12px',
            borderSpacing: 0,
            width: '100%',
            marginTop: theme.spacing(2),
            margin: 0,
        },
        '& th, & td': {
            borderBottom: borderStyle,
            borderRight: borderStyle,
            padding: theme.spacing(2, 3),
            textAlign: 'left',
        },
        '& th:last-child, & td:last-child': {
            borderRight: 0,
        },
        '& tr:last-child td': {
            borderBottom: 0,
        },
        '& th': {
            fontWeight: 500,
            background: theme.palette.ensightful.neutral[50],
        },
    };
};

const ChatMarkdownRoot = styled('div')(({ theme }) => getChatMarkdownStyles({ theme }));

const ChatMarkdown = ({ children }) => {
    if (!children) return null;

    return (
        <ChatMarkdownRoot>
            <ReactMarkdown components={{ a: ChatMarkdownLink, table: ChatMarkdownTable }} remarkPlugins={[remarkGfm]}>
                {preserveMarkdownLineBreaks(children)}
            </ReactMarkdown>
        </ChatMarkdownRoot>
    );
};

export default ChatMarkdown;
